// On a phone, the entries under a day header with an image stay folded until that image is tapped (`dayToShow`).
// A header without image has nothing to tap: its entries stay visible.
export function isEntryHiddenOnMobile(currentDay, dayToShow) {
  if (currentDay && !currentDay.hasImage) return false;
  return (currentDay ? currentDay.label : null) !== dayToShow;
}
